// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f1f23bdf","108":"e415db40","128":"5960ba7c","215":"030c28ea","246":"a80dd9a6","279":"d61ab130","283":"6f2a874f","355":"430b07b2","678":"4993efd2","756":"5dc9dcc6","770":"5a21604a"}[chunkId] + ".chunk.js";
};